import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import {
  GapNightAutomationDialogComponent,
  GapNightAutomationDialogInput,
} from './gap-night-automation-dialog.component'

@Injectable()
export class GapNightAutomationDialogService {
  constructor(private dialog: DialogService) {}

  public open(data?: GapNightAutomationDialogInput) {
    const defaultConfig: MatDialogConfig<GapNightAutomationDialogInput> = {
      width: '800px',
      height: 'auto',
      data: data || {},
    }

    return this.dialog.openVariableDialog(GapNightAutomationDialogComponent, defaultConfig)
  }
}
